<template>
  <div class="game">
    <div class="side-header visitor" :style="v.style">
      <div class="header side-header-left">
        <div class="spacer">
          <div class="text-pop-label">{{ v.team.city }}</div>
          <div class="text-pop">{{ v.team.nickname }}</div>
        </div>
        <div class="score" :class="{'loser': v.summary.PTS !== winner}">{{ v.summary.PTS }}</div>
      </div>
      <div class="header side-header-right">
        <div class="logo">
          <img :src="v.team.logo" />
        </div>
      </div>
    </div>
    <boxscore :boxscore="v.boxscore" :columns="columns" :summary="v.summary" />
    <hr />
    <div class="side-header home" :style="h.style">
      <div class="header side-header-left">
        <div class="spacer">
          <div class="text-pop-label">{{ h.team.city }}</div>
          <div class="text-pop">{{ h.team.nickname }}</div>
        </div>
        <div class="score" :class="{'loser': h.summary.PTS !== winner}">{{ h.summary.PTS }}</div>
      </div>
      <div class="side-header-right">
        <div class="logo">
          <img :src="h.team.logo" />
        </div>
      </div>
    </div>
    <boxscore :boxscore="h.boxscore" :columns="columns" :summary="h.summary" />
  </div>
</template>

<script>
import Boxscore from './Boxscore'
import { teams } from '../teams'

export default {
  name: 'GameDetail',
  components: {
    Boxscore,
  },
  props: {
    n: {
      type: Number,
      required: true,
      validator: (v) => Number(v) > 0,
    },
    visitor: {
      type: String,
      required: true,
    },
    home: {
      type: String,
      required: true,
    },
    boxscore: {
      type: Array,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      columns: [
        {
          field: 'Name',
          label: 'Name',
          width: '20%',
          numeric: false,
          cellClass: 'has-text-weight-bold lineheight-fix',
        },
        {
          field: 'MIN',
          label: 'MIN',
          numeric: true,
          width: '15px',
        },
        {
          field: 'PTS',
          label: 'PTS',
          numeric: true,
        },
        // {
        //   field: 'FG',
        //   label: 'FG',
        //   numeric: true,
        //   width: '15%',
        // },
        {
          field: 'FGM',
          label: 'FGM',
          numeric: true,
          // visible: false,
        },
        {
          field: 'FGA',
          label: 'FGA',
          numeric: true,
          // visible: false,
        },
        {
          field: 'FG%',
          label: 'FG%',
          numeric: true,
          // visible: false,
        },
        // {
        //   field: '3PT',
        //   label: '3PT',
        //   numeric: true,
        //   width: '15%',
        // },
        {
          field: '3ptM',
          label: '3PM',
          numeric: true,
          // visible: false,
        },
        {
          field: '3ptA',
          label: '3PA',
          numeric: true,
          // visible: false,
        },
        {
          field: '3P%',
          label: '3P%',
          numeric: true,
          // visible: false,
        },
        // {
        //   field: 'FT',
        //   label: 'FT',
        //   numeric: true,
        //   width: '15%',
        // },
        {
          field: 'FTM',
          label: 'FTM',
          numeric: true,
          // visible: false,
        },
        {
          field: 'FTA',
          label: 'FTA',
          numeric: true,
          // visible: false,
        },
        {
          field: 'FT%',
          label: 'FT%',
          numeric: true,
          // visible: false,
        },
        {
          field: 'OREB',
          label: 'OREB',
          numeric: true,
          width: '2.5%',
        },
        {
          field: 'DREB',
          label: 'DREB',
          numeric: true,
          width: '2.5%',
        },
        {
          field: 'REB',
          label: 'REB',
          numeric: true,
          width: '2.5%',
        },
        {
          field: 'AST',
          label: 'AST',
          numeric: true,
          width: '2.5%',
        },
        {
          field: 'TOV',
          label: 'TOV',
          numeric: true,
          width: '2.5%',
        },
        {
          field: 'STL',
          label: 'STL',
          numeric: true,
          width: '2.5%',
        },
        {
          field: 'BLK',
          label: 'BLK',
          numeric: true,
          width: '2.5%',
        },
        {
          field: 'PF',
          label: 'PF',
          numeric: true,
          width: '2.5%',
        },
        {
          field: 'PlusMinus',
          label: '+/-',
          numeric: true,
          width: '2.5%',
        },
      ],
    }
  },
  computed: {
    v () {
      const team = teams[this.visitor]
      const boxscore = this.boxscore.filter((row) => row.Team === team.short)
      const summary = boxscore.pop()
      const style = { background: `linear-gradient(90deg, #fff 25%, ${team.primary} 100%)`, color: team.secondary }
      return {
        team, boxscore, style, summary,
      }
    },
    h () {
      const team = teams[this.home]
      const boxscore = this.boxscore.filter((row) => row.Team === team.short)
      const summary = boxscore.pop()
      const style = { background: `linear-gradient(90deg, #fff 25%, ${team.primary} 100%)`, color: team.secondary }
      return {
        team, boxscore, style, summary,
      }
    },
    winner () {
      return this.v.summary.PTS > this.h.summary.PTS ? this.v.summary.PTS : this.h.summary.PTS
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/ th {
  text-transform: uppercase;
  font-size: 10px;

  &.header {
    background-color: $vs-component-placeholder-color;
  }
}

/deep/ .b-table {
  background: #fff;
  z-index: 5;
  position: relative;
}

.game {
  font-size: 90%;
  width: 100%;
  padding: 1rem 2rem;
  width: 100%;
  max-height: 100%;
  overflow-y: auto;
}

.text-pop {
  font-family: 'Inconsolota', sans-serif;
  font-size: 64px;
  line-height: 66px;
  font-weight: 900;
}

.text-pop-label {
  font-size: 20px;
  font-weight: 300;
  opacity: 0.9;
  margin-right: 8px;
  text-transform: uppercase;
  padding-left: 6px;
  line-height: 28px;
}

.side-header {
  padding: .5em;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  position: relative;

  .home {
    background: #ccc;
  }

  &-right, &-left {
    text-align: left;
  }

  .header {
    display: flex;
    align-items: flex-end;

    .spacer {
      width: 300px;
    }

    .score {
      font-size: 84px;
      line-height: 84px;
      font-weight: 900;
      padding-left: 16px;

      &.loser {
        opacity: 0.6;
      }
    }
  }

  .logo {
    position: absolute;
    top: calc(-72px / 2);
    right: 10%;
    z-index: 1;
    width: 192px;
    height: 192px;

    img {
      height: auto;
      opacity: 0.2;
    }
  }
}
</style>
